import React from "react"
import classes from "./Ab2.module.css"
import a2 from "./../../Assest/vis.jpg";
import a1 from "./../../Assest/mis.jpg";
import Fade from 'react-reveal/Fade';

const Ab2 = () => {
    return (
        
    <>


<div className={classes.a1}>
 <Fade left>
<div  className={classes.a12}>
        <img src={a2} className={classes.img} />
</div>
</Fade>
<div className={classes.a11}>
    <Fade right>
<h3 className={classes.ih4}>Our Vision</h3>
<p className={classes.ih41}>
  To be the most trusted choice for students and parents seeking reliable career guidance, 
  offering complete and high-quality counselling solutions that empower confident academic 
  and professional decisions.
</p>

<p className={classes.ih41}>
  We aim to become a leading career guidance platform by delivering comprehensive, ethical, 
  and personalized counselling services. Our commitment to excellence ensures that every 
  student receives clear direction, expert mentorship, and dedicated support to build a 
  successful future.
</p>

</Fade>
</div>


</div>



<div className={classes.a1}>

<div  className={classes.a11}>
     <Fade left>
    <h3 className={classes.ih4}>Our Mission</h3>
<p className={classes.ih41}>
  Our mission is to empower students with accurate, ethical, and personalized career guidance 
  that helps them make confident academic and professional decisions.
</p>

<p className={classes.ih41}>
  We strive to combine expert counselling, in-depth analysis, and compassionate support to 
  understand each student’s strengths and aspirations. Through clarity, transparency, and 
  continuous guidance, we help students transform their potential into successful and 
  fulfilling career journeys.
</p>

</Fade>
</div>
<div className={classes.a12}>
        <Fade right>
    <img src={a1} className={classes.img} />
    </Fade>
</div>

</div>



        </>
    )
}

export default Ab2;